module.exports = __webpack_public_path__ + "media/corporate-image/monodukuri-89a22909f6e7e7eaf02f5c34c00974a8.png";